import styled from "styled-components";

const QUESTIONS = [
  "What is Sure Service?",
  "What is your tech stack?",
  "How can I contact you?",
];

type Props = {
  onSelect: (question: string) => void;
  disabled?: boolean;
};

const SuggestedQuestions = ({ onSelect, disabled }: Props) => (
  <Root>
    {QUESTIONS.map((q) => (
      <Chip
        key={q}
        type="button"
        disabled={disabled}
        onClick={() => onSelect(q)}
      >
        {q}
      </Chip>
    ))}
  </Root>
);

export default SuggestedQuestions;

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const Chip = styled.button`
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  border: 1px solid var(--border-accent);
  background: var(--accent-bg);
  color: var(--text-label);
  font-size: 0.78rem;
  cursor: pointer;
  transition: var(--transition);

  &:hover:not(:disabled) {
    background: var(--accent-bg-hover);
    color: var(--green);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
